import { render } from "./index.vue?vue&type=template&id=f160d3e6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f160d3e6&lang=css"

import exportComponent from "C:\\Users\\zhang\\Desktop\\loan\\loanweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__